import { Autocomplete, SxProps, TextField, Theme } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlPlannerVisitStatus } from "~/__generated__";

type Props = {
    value: GqlPlannerVisitStatus | null;
    onChange: (value: GqlPlannerVisitStatus | null) => void;
    sx?: SxProps<Theme>;
};

export default function PlannerVisitStatusSelect({ value, onChange, sx }: Props) {
    const { t } = useTranslation("planner");

    const options = Object.values(GqlPlannerVisitStatus).map(status => ({
        value: status,
        label: t(`PlannerVisitStatusSelect.visitStatusValue.${status}`),
    }));

    return (
        <Autocomplete
            size="small"
            sx={sx}
            options={options}
            value={options.find(option => option.value === value) ?? null}
            onChange={(_, newValue) => onChange(newValue?.value ?? null)}
            getOptionLabel={option => option.label}
            getOptionKey={option => option.value}
            isOptionEqualToValue={(option, val) => option.value === val.value}
            renderInput={params => <TextField {...params} label={t("PlannerVisitStatusSelect.labelStatus")} variant="outlined" />}
        />
    );
}
